import { useQuery } from '@tanstack/react-query';
import {
  fetchAlertHistorySummary,
  fetchAmDashboard,
  fetchAmDashboardAccountNames,
  fetchCallHistorySummary,
  fetchEmailHistorySummary,
} from '../api';
import type { AmDashboardFilters, AmHistorySummaryFilters } from '../types';

export const amDashboardKeys = {
  all: ['am-dashboard'] as const,
  dashboard: (filters?: AmDashboardFilters) =>
    [...amDashboardKeys.all, 'data', filters] as const,
  alertHistorySummary: (filters?: AmHistorySummaryFilters) =>
    [...amDashboardKeys.all, 'alert-history-summary', filters] as const,
  emailHistorySummary: (filters?: AmHistorySummaryFilters) =>
    [...amDashboardKeys.all, 'email-history-summary', filters] as const,
  callHistorySummary: (filters?: AmHistorySummaryFilters) =>
    [...amDashboardKeys.all, 'call-history-summary', filters] as const,
  accountNames: () => [...amDashboardKeys.all, 'account-names'] as const,
};

export function useAmDashboard(filters: AmDashboardFilters) {
  return useQuery({
    queryKey: amDashboardKeys.dashboard(filters),
    queryFn: () => fetchAmDashboard(filters),
  });
}

export function useAmDashboardAccountNames() {
  return useQuery({
    queryKey: amDashboardKeys.accountNames(),
    queryFn: fetchAmDashboardAccountNames,
    staleTime: 5 * 60 * 1000,
  });
}

export function useAlertHistorySummary(filters: AmHistorySummaryFilters = {}) {
  return useQuery({
    queryKey: amDashboardKeys.alertHistorySummary(filters),
    queryFn: () => fetchAlertHistorySummary(filters),
  });
}

export function useEmailHistorySummary(filters: AmHistorySummaryFilters = {}) {
  return useQuery({
    queryKey: amDashboardKeys.emailHistorySummary(filters),
    queryFn: () => fetchEmailHistorySummary(filters),
  });
}

export function useCallHistorySummary(filters: AmHistorySummaryFilters = {}) {
  return useQuery({
    queryKey: amDashboardKeys.callHistorySummary(filters),
    queryFn: () => fetchCallHistorySummary(filters),
  });
}
